import React, {useEffect, useState} from 'react'
import DataContext from "../mapanalysis/cxContext"
import {css} from "glamor";
import { Tab, Row, Tabs, Col, Button, Modal,Form} from 'react-bootstrap'
import {CropValueChart} from '../mapanalysis/ButtonCharts/cropValueChart';
import {CropYieldChart} from '../mapanalysis/crops/cropStatYieldChart';
import { SuitabilityModel } from '../mapanalysis/crops/cropSuitabilityModel';
import {LivestockStatChart} from '../mapanalysis/livestock/livestockStatChart';
import {TotalLivestockChart} from '../mapanalysis/livestock/totallivestockChart';
import {ValueChainChart} from '../mapanalysis/ButtonCharts/vChainsChart';
import {SelectCropChart} from '../mapanalysis/seCropType';
import {SelectCountyChart} from '../mapanalysis/seCountiesChart';
import { CropStatChart } from '../mapanalysis/crops/cropStatChart';
import { DownloadChrt } from '../mapanalysis/download';
import { FodderChart } from '../mapanalysis/livestock/fodderAvailability'

export default function Agriculture() {
    const [sel, setSel] = useState('Horticulture');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [checked, setChecked] = useState(false); // toggle check button
    const handleClick = () => setChecked(!checked);

    const handleShow = () => {
        if (typeof window.MSELECTCOUNTY === 'undefined') {
            // alert the user to  make a selection
            window.alert("Select at least one county")

        } else if (typeof window.MVALUECHAIN === 'undefined') {

            window.alert("You need to  select  at least one Value Chain")

        } else if (typeof window.MSSELECROPTYPE === 'undefined') {

            window.alert("You need to  select at least one Crop type / Livestock")
        } else {
            setShow(true)
        }
    }
    const handleRequestData = () => {
        handleShow();
    };
    // monitor the select value chain method
    const handleSelonChange = (e) => {
      
        setSel(e.target.value);
    };
        /*test for select*/
    const getElementByIdAsync = id => new Promise(resolve => {
        const getElement = () => {
            const element = document.getElementById(id);
            if (element) {
                resolve(element);
            } else {
                requestAnimationFrame(getElement);
            }
        };
        getElement();
    });

    // use effect to  check whether the DOM has been loaded
    // check if the select value chains drop down has been rendered
    // if yes attch  an onChange event listener to  it
    // Capture any event change on the element.
    useEffect(() => {
        async function getEl() {
            const divElement = await getElementByIdAsync('selectedmenu');
            if (divElement) {
               
                divElement.getElementsByClassName("dc-select-menu")[0].addEventListener("change", handleSelonChange);
            }
        }
        getEl()
    }, []);

    /* jsx css styles */
    const chart_widget_style = css({
        background: "white",
        // border: "3px solid aliceblue",
    });
    const text_icons_css = css({
        textAlign: "center",
        boxShadow: " 0 1px 2px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.07), 0 4px 8px rgba(0,0,0,0.07),0 8px 16px rgba(0,0,0,0.07),0 16px 32px rgba(0,0,0,0.07),0 32px 64px rgba(0,0,0,0.07);",

        width: "6.5rem",
        "& btn": {
            padding: "0px !important"
        }
    });
    
  const table_style = css({
    overflowY: "scroll",
    overflowX: "scroll",
    maxHeight: "70vh",
    width: "100%",
    height: "17rem",

    "& tr": {
      "&:hover": {
        background: "#dddd",
      },
    },
    "& td": {
      // padding:rhythm(0.1),
      textAlign: "left",
      borderTop: "1px dashed #ddd",
      borderBottom: "1px dashed #ddd",
      borderLeft: "1px dashed #ddd",
      borderRight: "1px dashed #ddd",
      paddingLeft: "5px",
      paddingRight: "5px",
      fontSize: "0.8rem !important",
      color: "#0152aa",
      wordWrap: "normal"
    },
    "& th":{
      border: "1px solid #ddd0d0",
      fontSize:" 0.7rem",
      color: "#0152aa"
    }
  });
    const modal_dialog = css({
        fontSize: "0.9rem",
        height: "27rem",
        "& select": {
            width: "11.4rem !important",
            border: "1px solid #1867ab !important",
            height: "28px !important",
            borderRadius: "6px !important",
            marginRight: "6px !important",
            color: "black !important",
            background: "white !important"
        },
        "& label": {
            paddingLeft: "15px",
            paddingRight: "10px"
        },
        "& input": {
            maxWidth: "13rem",
            marginLeft: "1rem",
            marginRight: "4rem",
            border: "1px solid #1867ab",
            height: "28px"
        },
        "& hr": {
            border: " 0.1px solid #e8e6e6",
            width: " 100%",
            marginTop: "-0.2rem"
        },
        "tab tab-content": {
            color: "#555",
            background: "#fff",
            fontSize: "16px",
            letterSpacing: "1px",
            lineHeight: "25px",
            padding: "20px",
            borderBottom: "4px solid #0670bc",
            boxShadow: "0 0 7px rgba(0,0,0,0.1) inset",
            position: "relative"
        }
    });
    const axis_ticks = css({
        "& g g.axis.x ": {
            display: "none"
        },
    });
    return (
        <div>
            <DataContext>
                <div class="row">
                    <div className="col-md-12">
                        <div style={{ display: "flex",width: "90vw"  }}>
                            <Col md={3}
                                id="selectedmenu">
                                <ValueChainChart/>
                            </Col>
                            <Col md={3}
                                id="options">
                                <SelectCropChart/>
                            </Col>
                            <Col md={4}
                                id="admin_level">
                                <SelectCountyChart/>
                            </Col>
                             <Col md={3}> 
                                <Row style={{ width: "100%" }}>
                                    <Button id="indicators" style={{width:"11rem",fontSize:"0.7rem",marginTop:"0rem"}} onClick={handleShow} variant="primary" >SUBMIT INTEREST ON AVAILABLE DATASETS</Button>
                                </Row>
                            </Col> 
                        </div>
                    </div>
                </div>

                <Row around="xs" {...chart_widget_style}
                    style={{display: 'block',marginTop: "1rem"}}>

                    { sel == "Horticulture" ? (
                        <Tabs defaultActiveKey="home" id="main" className="mb-3" style={{marginRight: "1rem"}}>
                            <Tab eventKey="home" title="Crop Productivity">
                                <Row>
                                    <div style={{display: "flex",marginLeft: "1.5rem",marginRight:"4rem",textAlign: "center" }}>
                                        <Col md={4}
                                            style={{border: "1px solid #c3c3c3",margin: "5px"}}>
                                            <Row>
                                                <h6 style={{textDecoration: "underline",textAlign: "center",width: "100%"}}>
                                                    Crop Statistics
                                                </h6>
                                            </Row>
                                            <Row style={
                                                {
                                                    display: "flex",
                                                    marginLeft: "1rem"
                                                }
                                            }>
                                                <Col md={6}
                                                    style={
                                                        {marginLeft: "-2rem"}
                                                }>
                                                    <Row>
                                                        <div>
                                                            <h6 style={{textDecoration: "underline"}}>
                                                                Yield(Ton/ha)
                                                            </h6>
                                                            <Button variant="light" {...text_icons_css}>
                                                                <CropYieldChart/>
                                                            </Button>
                                                        </div>
                                                    </Row>
                                                    <Row>
                                                        <div>
                                                            <h6>Value (KES)</h6>
                                                            <Button variant="light" {...text_icons_css}>
                                                                <CropValueChart/>
                                                            </Button>
                                                        </div>
                                                    </Row>
                                                </Col>
                                                <Col md={6}>
                                                    <CropStatChart/> </Col>
                                            </Row>
                                        </Col>
                                        
                                        <Col md={4}
                                            style={
                                                {
                                                    border: "1px solid #c3c3c3",
                                                    margin: "5px"
                                                }
                                        }>
                                            <div style={
                                                {textAlign: "center"}
                                            }>
                                                <h6 style={
                                                    {textDecoration: "underline"}
                                                }>
                                                    Crop suitability model
                                                </h6>
                                                <div >
                                                    <SuitabilityModel />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={4}style={{border: "1px solid #c3c3c3",margin: "5px"}}>
                                       <Row>
                                            <Col md={12} {...table_style}>
                                                    <div style={{ textAlign: "center" }}>
                                                        <DownloadChrt />
                                                    </div>
                                            </Col>
                                       </Row>
                                        </Col>
                                    </div>
                                </Row>
                            </Tab>

                        </Tabs>
                    ) : (
                        <Tabs defaultActiveKey="home" id="main" className="mb-3">
                            <Tab eventKey="home" title="Livestock Productivity">
                            <Row>
                                    <div style={{display: "flex",marginLeft: "1.5rem",marginRight:"4rem",textAlign: "center" }}>
                                        <Col md={4}
                                            style={{border: "1px solid #c3c3c3",margin: "5px"}}>
                                            <Row>
                                                <h6 style={{textDecoration: "underline",textAlign: "center",width: "100%"}}>
                                                    Livestock Statistics
                                                </h6>
                                            </Row>
                                            <Row style={{display: "flex", marginLeft: "1rem"}}>
                                                <Col md={4} style={{marginLeft: "-2rem"}}>
                                                    <Row>
                                                        <div><h6 style={{textDecoration: "underline"}}>Value (KES)</h6>
                                                            <Button variant="light" {...text_icons_css}>
                                                                <TotalLivestockChart/>
                                                            </Button>
                                                        </div>
                                                    </Row>
                                                    {/* <Row>
                                                        <div>
                                                            <h6>Value (KES)</h6>
                                                            <Button variant="light" {...text_icons_css}>
                                                                <LivestockStatChart/>
                                                            </Button>
                                                        </div>
                                                    </Row> */}
                                                </Col>
                                                <Col md={8}><LivestockStatChart/></Col>
                                            </Row>
                                        </Col>
                                        
                                        <Col md={4} style={{ border: "1px solid #c3c3c3", margin: "5px"}}>
                                            <div style={{textAlign: "center"}}><h6 style={{textDecoration: "underline"}}>
                                                    Fodder and Food Availability
                                                </h6>
                                                <div >
                                                    <FodderChart/>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={4}style={{border: "1px solid #c3c3c3",margin: "5px"}}>
                                       <Row>
                                            <Col md={12} {...table_style}>
                                                    <div style={{ textAlign: "center" }}>
                                                        <DownloadChrt />
                                                    </div>
                                            </Col>
                                       </Row>
                                        </Col>
                                    </div>
                                </Row>
                            </Tab>
                        </Tabs>
                    )
                } </Row>
            </DataContext>
            <Modal {...modal_dialog}
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Data Request Form</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-3">
                        <Form.Group as={Col}
                            controlId="formGridEmail">
                            <Form.Label>Select Datasets</Form.Label>
                        </Form.Group>
                        <hr />
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col}
                            controlId="formGridState">
                            <Form.Label>Value Chain</Form.Label>
                            <Form.Control type="email" placeholder="Select  Data"
                                value={

                                    window.MVALUECHAIN 
                                }
                                readOnly />
                        </Form.Group>

                        <Form.Group as={Col}
                            controlId="formGridState">
                            <Form.Label>Location</Form.Label>
                            <Form.Control type="email" placeholder="Select data" value={ window.MSELECTCOUNTY } readOnly />
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col}
                            controlId="formGridState">
                            <Form.Label>Crops / Livestock</Form.Label>
                            <Form.Control type="email" placeholder="Select data"  value={window.MSSELECROPTYPE} readOnly />
                        </Form.Group>
                        <Form.Group className="mb-3" id="formGridCheckbox">
                            <Form.Label style={{ marginLeft: "2rem", marginTop: "2.3rem",marginRight:"4rem" }}>Confirm Selection </Form.Label>
                            <Form.Check type="checkbox"  style={{ marginTop: "-2.3rem" }}onClick={handleClick} checked={checked} />
                        </Form.Group>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="button-3-datarequest" variant="outline-primary"
                        onClick={handleClose}>
                        Close
                        </Button>
                    <Button id="send_indicators" className="button-3-datarequest" variant="outline-success"
                        disabled={
                            !checked
                        }
                        onClick={handleClose}>
                        Send Request
                        </Button>
                </Modal.Footer>
            </Modal>

        </div>
    )
}
